"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "9", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M8 8L16 16", stroke: "white", strokeWidth: "1.5" }),
    react_1.default.createElement("path", { d: "M8 16L16 8", stroke: "white", strokeWidth: "1.5" })));
